import React from "react";
import { styled } from "@mui/material/styles";
import ChatBubble from "@mui/icons-material/ChatBubble";
import CreditCardOff from "@mui/icons-material/CreditCardOff";
import EventBusy from "@mui/icons-material/EventBusy";

const BadgeWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  marginLeft: "auto",
  gap: "5px",
});

const Badge = styled("div")(({ color }) => ({
  backgroundColor: color,
  borderRadius: "10px",
  padding: "2px 6px",
  fontSize: "0.75rem",
  fontWeight: 600,
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "20px",
  gap: "3px",
}));

const BadgeCount = ({
  unreadMessageCount,
  unpaidFeesCount,
  unRespondedRequestsCount,
}) => {
  return (
    <BadgeWrapper>
      {unreadMessageCount > 0 && (
        <Badge color="#2CB045">
          <ChatBubble style={{ fontSize: 16, color: "#fff" }} />
          {unreadMessageCount}
        </Badge>
      )}
      {unpaidFeesCount > 0 && (
        <Badge color="#FF3B30">
          <CreditCardOff style={{ fontSize: 16, color: "#fff" }} />
          {unpaidFeesCount}
        </Badge>
      )}
      {unRespondedRequestsCount > 0 && (
        <Badge color="#FF3B30">
          <EventBusy style={{ fontSize: 16, color: "#fff" }} />
          {unRespondedRequestsCount}
        </Badge>
      )}
    </BadgeWrapper>
  );
};

export default BadgeCount;
